(function ($) {

  'use strict';

  $(document).ready(function () {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear()
    $('select').formSelect();
    $('.modal').modal();

    const datepickerDefaults = {
      container: 'body',
      format: "yyyy-mm-dd",
      firstDay: 1,
      autoClose: true,
      onSelect: testDate,
      i18n: {
        months: [
          'Januar',
          'Februar',
          'März',
          'April',
          'Mai',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'Dezember'
        ],
        monthsShort: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'Mai',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Okt',
          'Nov',
          'Dez'
        ],
        weekdays: [
          'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'
        ],
        weekdaysShort: [
          'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'
        ],
        weekdaysAbbrev: [
          'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'
        ],
        cancel: 'abbrechen',
        clear: 'zurücksetzen'
      }
    };

    $('.datepicker').each(function () {
      const opts = Object.assign({}, datepickerDefaults);
      const minAttr = $(this).attr('min');
      const maxAttr = $(this).attr('max');

      if (minAttr) {
        opts.minDate = new Date(minAttr + 'T00:00:00');
      }
      if (maxAttr) {
        opts.maxDate = new Date(maxAttr + 'T00:00:00');
      }

      if (!opts.maxDate) {
        opts.maxDate = currentDate;
      }

      opts.defaultDate = new Date(year - 30, month, day);
      var defaultYear = opts.defaultDate.getFullYear();

      if (opts.minDate && opts.maxDate) {
        // yearRange is centered on defaultDate, so use max distance to either bound
        opts.yearRange = Math.max(
          defaultYear - opts.minDate.getFullYear(),
          opts.maxDate.getFullYear() - defaultYear
        );
      } else {
        opts.yearRange = 100;
      }

      $(this).datepicker(opts);
    });

  });


  // Check for filled out date fields and update style class.
  const testDate = () => {
    const datePickerElements = $('.datepicker');
    datePickerElements.each((index, element) => {
      const picker = M.Datepicker.getInstance(element);
      if (picker.date !== undefined) {
        $(datePickerElements[index]).removeClass('empty');
      }
    });
  }

  const allSelects = $('.form-type-select select');

  // Set nicer "select" on page load.
  allSelects.each(function() {
    let value = $(this).val();
    if (value.length !== 0 && value !== 'All') {
      $(this).closest('.form-item').addClass('selected');
    }
  });

  // Toggle nicer "select" display.
  allSelects.on('change', function () {
    if ($(this).val().length === 0) {
      $(this).closest('.form-item').removeClass('selected');
    } else {
      $(this).closest('.form-item').addClass('selected');
    }
  });

  $(document).ready(() => {
    var search = location?.search?.substring(1);
    if(search) {
      const params = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
        return key === "" ? value : decodeURIComponent(value)
      })
      if (params?.form === 'counsel') {
        $('.overlay_wrapper.counsel').addClass('open');
      }
      else if (params?.form === 'register') {
        $('.overlay_wrapper.register').addClass('open');
      }
    }
  })

  //overlay toggle
  $('.toggleOverlay').on("click", function() {
    const e = $(this);
    if (e.hasClass('counsel')) {
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?form=counsel';
      window.history.pushState({path:newurl},'',newurl);
      $('.overlay_wrapper.counsel').addClass('open');
    } else if (e.hasClass('register')) {
      var newurl2 = window.location.protocol + "//" + window.location.host + window.location.pathname + '?form=register';
      window.history.pushState({path:newurl2},'',newurl2);
     $('.overlay_wrapper.register').addClass('open');
    } else {
      e.siblings('.overlay_wrapper').addClass('open');
    }

    $('body').addClass('no-scroll');
  });

  $('.overlay_wrapper').on("click", (e) => {
    if ($(e.target).hasClass('open')) {
      var newurl2 = window.location.href.replace(/form=([^&#]*)/, '');
      window.history.pushState({path:newurl2},'',newurl2);
      $(e.target).removeClass('open');
      $('body').removeClass('no-scroll');
    }
  });

  $('.overlay_close').on("click", (e) => {
    var newurl2 = window.location.href.replace(/form=([^&#]*)/, '');
    window.history.pushState({path:newurl2},'',newurl2);
    $('.overlay_wrapper').removeClass('open');
    $('body').removeClass('no-scroll');
  });

  if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    $('input.datepicker').attr('type','text');
  }

  // Update date filed on keyboard input for datepicker fields.
  $('.webform-submission-form input.form-date.datepicker').on('keydown', function() {
    var input = $(this);
    input.removeClass('empty');
    input.parent().find('label').addClass('active-fixed');
  });

})(jQuery);
